import { EmergencyBanner } from '@munifocus/ui';
import { useTranslation } from 'react-i18next';

/**
 * Threads the s. 144(9) {@link EmergencyBanner} into a workflow screen. Renders
 * nothing unless the file carries the emergency flag, so the layout wrappers can
 * mount it unconditionally and let it decide. Localized copy explains the dual
 * routing (Form 4 on a shortened deadline + direct work execution) per the
 * emergency-bypass brief (`docs/gov` s. 5).
 */
export function FileEmergencyBanner({ emergency }: { emergency: boolean }) {
  const { t } = useTranslation();
  if (!emergency) return null;
  return (
    <EmergencyBanner eyebrow={t('gov.emergency.eyebrow')} sx={{ mb: 2 }}>
      {t('gov.emergency.bypassBody')}
    </EmergencyBanner>
  );
}
